export default __webpack_public_path__ + "static/media/sme-banner1.02fa8eae.png";